import React from "react";
import ReactDOM from "react-dom/client";
import App from "./SpaApp";
import "./styles/theme-variables.css";
import "./styles/tailwind.css";
// NU DATA design-system layer (#601 S1) — order matters:
// fonts → universal tokens/classes → brand theme values.
import "./styles/nu/nu-fonts.css";
import "./styles/nu/nu-tokens.css";
import "./styles/nu/nu-brand.css";

// Global unhandled error handlers
window.addEventListener("unhandledrejection", (event) => {
  console.error("[Unhandled Promise Rejection]", event.reason);
  event.preventDefault();
});

window.addEventListener("error", (event) => {
  console.error("[Uncaught Error]", event.error || event.message);
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
